import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import InstallPage from "@/pages/InstallPage";
import Dashboard from "@/pages/Dashboard";
import CameraCapture from "@/pages/CameraCapture";
import TyreForm from "@/pages/TyreForm";
import TyreDetail from "@/pages/TyreDetail";
import Statistics from "@/pages/Statistics";
import SoldArchive from "@/pages/SoldArchive";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/install" element={<InstallPage />} />
            
            {/* Protected routes */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/capture" element={<CameraCapture />} />
              <Route path="/form" element={<TyreForm />} />
              <Route path="/tyre/:code" element={<TyreDetail />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/sold" element={<SoldArchive />} />
            </Route>

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
